// pages/mypage/MyPagePoint.tsx
import { useEffect, useState } from "react";
import MyPageLayout from "../../components/mypage/MyPageLayout";
import { getApiUrl, fetchWithAuth } from "../../api";

interface PointHistoryItem {
  id: number;
  type: 1 | 2;
  description: string | null;
  amount: number;
  balance_after: number;
  ticket_no: string | null;
  created_at: string;
}

interface MyPointHistoryResponse {
  total_points: number;
  total: number;
  histories: PointHistoryItem[];
}

export default function MyPagePoint() {
  const [data, setData] = useState<MyPointHistoryResponse | null>(null);
  const [loading, setLoading] = useState(true);
  // 상단에 추가
  const RULE_TYPE_LABEL: Record<string, string> = {
    SIGNUP: "회원가입",
    ATTENDANCE: "출석체크",
    PROGRAM_APPLY: "프로그램 신청",
    PROGRAM_COMPLETE: "프로그램 완료",
    PROGRAM_CANCEL: "프로그램 취소",
    CONSULT_APPLY: "상담 신청",
    CONSULT_COMPLETE: "상담 완료",
    CONSULT_CANCEL: "상담 취소",
    SPACE_APPLY: "공간예약 신청",
    SPACE_COMPLETE: "공간예약 완료",
    SPACE_CANCEL: "공간예약 취소",
    LOCKER_APPLY: "금고 신청",
    LOCKER_CANCEL: "금고 취소",
    LOAN_BORROW: "도서 대출",
    LOAN_RETURN: "도서 반납",
  };

  useEffect(() => {
    (async () => {
      try {
        const res = await fetchWithAuth(
          getApiUrl("/marubit/api/point/me?page=1&limit=50")
        );
        if (res.ok) setData(await res.json());
      } catch (e) {
        console.error("마루 포인트 내역 로딩 실패:", e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const list = data?.histories ?? [];

  return (
    <MyPageLayout title="마루 포인트 내역">
      <div className="flex flex-col gap-5">

        {/* 보유 포인트 카드 */}
        <div className="bg-white rounded-2xl border border-[#f0ebe7] shadow-[0_2px_12px_rgba(136,114,103,0.08)] px-7 py-5 flex items-center justify-between">
          <div>
            <p className="m-0 text-[13px] text-gray-400 font-medium">현재 보유 마루</p>
            <p className="m-0 text-[28px] font-black text-[#f5a623] mt-1">
              {loading ? "-" : (data?.total_points ?? 0).toLocaleString()}
              <span className="text-[16px] font-bold ml-1">마루</span>
            </p>
          </div>
          <div className="w-[56px] h-[56px] rounded-full bg-[#fffbf2] border border-[#fde9c0] flex items-center justify-center">
            <svg viewBox="0 0 24 24" width={28} height={28} fill="none" stroke="#f5a623" strokeWidth={1.5}>
              <circle cx="12" cy="12" r="9" />
              <text x="12" y="17" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#f5a623" stroke="none">P</text>
            </svg>
          </div>
        </div>

        {/* 내역 테이블 */}
        <div className="bg-white rounded-2xl border border-[#f0ebe7] shadow-[0_2px_12px_rgba(136,114,103,0.08)] overflow-hidden">
          <div className="px-6 py-4 border-b border-[#f5f0ec]">
            <p className="m-0 text-[15px] font-bold text-[#3d2f2a]">적립/사용 내역</p>
          </div>

          {loading ? (
            <div className="py-16 text-center text-[14px] text-gray-400">불러오는 중...</div>
          ) : list.length === 0 ? (
            <div className="py-16 text-center text-[14px] text-gray-400">내역이 없습니다.</div>
          ) : (
            <div className="divide-y divide-[#f5f0ec]">
              <div className="grid grid-cols-4 px-6 py-3 bg-[#fdf9f7]">
                {["구분", "내용", "마루", "잔여 마루"].map((h) => (
                  <span key={h} className="text-[12px] text-gray-400 font-semibold">{h}</span>
                ))}
              </div>
              {list.map((item) => (
                <div key={item.id} className="grid grid-cols-4 px-6 py-4 items-center hover:bg-[#fdf9f7] transition-colors">
                  <span>
                    <span className={`inline-block px-2 py-[2px] rounded-full text-[11px] font-bold ${
                      item.type === 1 ? "bg-[#fff3e0] text-[#f5a623]" : "bg-[#f0ebe7] text-[#887267]"
                    }`}>
                      {item.type === 1 ? "적립" : "사용"}
                    </span>
                  </span>
                  <span className="text-[13px] text-[#3d2f2a]">
                    {item.description ?? "-"}
                  </span>
                  <span className={`text-[14px] font-bold ${item.type === 1 ? "text-[#f5a623]" : "text-[#887267]"}`}>
                    {item.type === 1 ? "+" : "-"}{item.amount.toLocaleString()}마루
                  </span>
                  <span className="text-[13px] text-gray-500">{item.balance_after.toLocaleString()}마루</span>
                </div>
              ))}
            </div>
          )}
        </div>

      </div>
    </MyPageLayout>
  );
}